import { connect } from 'react-redux'

import WorkSummaryWorkOrderDetailsContainer from './work-summary-work-order-details-container'

function mapStateToProps (state, ownProps) {
  return {
    workOrderId: ownProps.params.workSummaryId.replace('qa-', '')
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkSummaryWorkOrderDetailsContainer)



// WEBPACK FOOTER //
// ./src/containers/work-summaries/work-summary-details-container.js